<template>
    <div id="app">
        <template v-show="!appLoading">
            <div
                :class="[
                    $route.name == 'homepage' ? `home bg-${img}` : 'home-more',
                    $route.name == 'send-shipment' ? `no-margin` : '',
                    $route.meta.unautherized ? `no-margin` : '',
                    $route.meta.publicPage ? `no-margin` : '',
                    $route.meta.autherizedAndNotVerified ? `no-margin` : '',
                ]"
            >
                <router-view></router-view>
            </div>
        </template>
        <loader :trigger="appLoading" :message="message"></loader>
    </div>
</template>

<script>
import { globalEvent } from "@/main";
import { Bus } from "./main";
import loader from "@/components/Loader.vue";

export default {
    components: {
        loader,
    },
    data() {
        return {
            appLoading: false,
            message: "",
            img: 0,
        };
    },
    created() {
        const html = document.documentElement; // returns the html tag
        html.setAttribute("lang", this.$i18n.locale);
        globalEvent.$on("loading", (value) => {
            if (value.status) {
                this.appLoading = value.status;
                this.message = value.message;
            } else {
                this.appLoading = false;
            }
        });
    },
    mounted() {
        Bus.$on("changebg", (active) => {
            this.img = active;
        });
        document.body.style.zoom = "90%";

        // setInterval(() => {
        //     this.img = Math.floor(Math.random() * 2 + 1);
        // }, 5000);
    },
};
</script>

<style lang="scss">
//Modifying Bulma\Buefy

//Importing Bulma's Core
@import "../src/assets/styles/flaticon/flaticon.css";
@import "../src/assets/styles/flaticon2/flaticon.css";
@import "~bulma/sass/utilities/_all";

.vti__input {
    direction: ltr !important;
}

.vue-tel-input {
    box-shadow: none !important;
    background: #f6f6ff !important;
    border-radius: 5px !important;
    border: none !important;

    input {
        background: #f6f6ff !important;
    }
}

.select select option:disabled {
    background: #ddd !important;
}

.carousel-slides.has-grayscale.has-opacity {
    padding: 0px 70px !important;
}

.bg-white {
    background: white;
}

.st-table {
    border-radius: 7px;
    padding: 1px 8px;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;

    &:lang(ar) {
        font-size: 12px;
    }
}

.status-issued {
    background: #fafafa;
}

.status-pending {
    background: #4952ff70;
}

.status-paid {
    background: #50e3c2;
}

button {
    &:focus {
        outline: none !important;
    }
}

.login-bg-1 {
    background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
        url("./assets/images/login-bg-1.jpg") !important;
}

.login-bg-2 {
    background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
        url("./assets/images/login-bg-2.jpg") !important;
}

.login-bg-3 {
    background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
        url("./assets/images/login-bg-3.jpg") !important;
}

* {
    -webkit-appearance: none;
    -moz-appearance: none;
    scroll-behavior: smooth;

    &:lang(en) {
        font-family: Circular !important;
    }
}

// .home-more {
//     margin-top: 120px !important;
// }

.no-margin {
    margin-top: 0 !important;
}

.home {
    margin-top: 80px !important;
}

.SMOnly {
    display: none !important;
}

@media screen and (max-width: 750px) {
    #sm-table {
        .table {
            margin: 10px 0 !important;
            padding: 0 !important;
        }
    }

    .LGOnly {
        display: none !important;
    }
    .SMOnly {
        display: block !important;
    }
}

.bg-0 {
    background-image: url("./assets/images/bg-0.jpg") !important;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-duration: 1s;
    animation-fill-mode: forwards;
}

.bg-1 {
    background-image: url("./assets/images/bg-1.jpg") !important;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-duration: 1s;
    animation-fill-mode: forwards;
}

.bg-2 {
    background-image: url("./assets/images/bg-2.jpg") !important;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-duration: 1s;
    animation-fill-mode: forwards;
}

.bg-3 {
    background-image: url("./assets/images/bg-3.jpg") !important;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-duration: 1s;
    animation-fill-mode: forwards;
}

.bg-4 {
    background-image: url("./assets/images/bg-4.jpg") !important;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-duration: 1s;
    animation-fill-mode: forwards;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.modal {
    z-index: 100 !important;
}

.bg-black {
    .welcome-user {
        background-color: #ffffff20 !important;

        .user-name {
            color: white !important;
        }
    }
}

.reg-bg,
.app-auth-page {
    background-image: url("./assets/images/reg-bg.png") !important;
    background-size: cover !important;
    z-index: 9999 !important;
    position: relative;

    &::after {
        content: "";
        background-image: url("./assets/images/sign.svg") !important;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        bottom: -35px;
        right: -30px;
        z-index: 5;
        width: 550px;
        height: 550px;

        @media screen and (max-width: 1000px) {
            width: 400px;
            height: 400px;
        }

        @media screen and (max-width: 600px) {
            display: none;
        }
    }

    // &::before {
    //     content: "";
    //     background-image: url("./assets/images/sign-logo.svg") !important;
    //     background-size: contain;
    //     background-repeat: no-repeat;
    //     position: absolute;
    //     top: 40px;
    //     left: 15px;
    //     z-index: 5;
    //     width: 200px;
    //     height: 200px;
    // }
}

.itemParent {
    span.is-top {
        width: 100% !important;
    }
}

.b-checkbox {
    opacity: 0.3 !important;
}

.font-10 {
    font-size: 10px !important;
}

.basic-select {
    .ul {
        max-height: 195px !important;
        overflow-y: scroll;
    }
}

span.select {
    width: 100%;

    select {
        padding-bottom: 0;
    }
}

.pointer {
    cursor: pointer;
}

.select-head.activated {
    border-color: #4bcaae !important;
}

.search-box.active {
    border-color: #4bcaae !important;
}

.search-box::before {
    background-color: #4bcaae !important;
}

a {
    outline: none;
}

.auth-button {
    border: none;
    font-size: 15px !important;
    color: #000;
    background: none;
    transition: 0.3s;
    cursor: pointer;
    padding: 7px 15px !important;
    border-radius: 10px;
    outline: none;

    &:hover {
        background: #eee;
    }

    &.primary-btn {
        background: #eee !important;

        &:hover {
            background: #4952ff !important;
            color: white;
        }
    }
}

button {
    &:lang(ar) {
        font-family: AlkonFont !important;
    }
}

.pagination {
    direction: ltr !important;
}

.button.is-primary {
    color: #fff !important;
}

.mdi-hand-left,
.mdi-printer {
    color: #888;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.select:not(.is-multiple):not(.is-loading)::after {
    border-color: #686868 !important;
}

input {
    border: none;
    outline: none;
}

input:invalid {
    border: none;
    box-shadow: none;
}

input:active {
    outline: none;
}

input:focus {
    border-color: transparent;
}

.select select {
    width: 100% !important;
}

.table {
    background: none !important;
}

$primary: #4952ff;
$secondary: #93a2dd;
$secondary-hover: #5d78ff;
$primary-invert: findColorInvert($primary);
$grey-lightest: #f2f2f280;
$grey-lighter: #c2c2c2;
$table-cell-border: $grey-lightest;
$dark: hsl(0, 0%, 29%);
$error: #eb6174;
$footer-background-color: $grey-lightest;
$table-check-color: #99a6bf;

.is-danger {
    color: $error !important;
    border-color: $error !important;
}

.is-error {
    color: $error;
}

is-info {
    color: "black";
}

.is-success {
    color: $primary;
}

.is-bg-secondary {
    transition: 0.25s linear;
    color: white !important;
    background-color: $secondary !important;

    &:hover {
        background-color: $secondary-hover !important;
    }
}

.is-bg-secondary-hovered {
    color: white !important;
    background-color: $secondary-hover !important;
}

.color-is-error {
    background-color: #cccccc !important;

    .text {
        color: black !important;
    }

    button {
        background-color: $error !important;
        color: white !important;
    }
}

.has-text-danger,
.has-text-error {
    color: $error !important;
}

.is-dark {
    background-color: $dark !important;
    color: white !important;
}

$colors: (
    "primary": (
        $primary,
        $primary-invert,
    ),
);

//Set our custom fonts
@import "../src/assets/fonts/font";
$family-primary: Futura;

//we directly set the #app to have this color
#app {
    background-color: $grey-lightest;
    min-height: 100vh;
    overflow: hidden;
}

.has-text-centered {
    text-align: center !important;
}

.title {
    color: #000 !important;
}

body {
    color: #000 !important;
    font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
        Helvetica Neue, sans-serif !important;
}

.b-checkbox.checkbox input[type="checkbox"] + .check {
    background: white !important;
    border: 2px solid #333 !important;
}

.th-wrap {
    color: #686868;
}

//Fixes for the step component
.b-steps .steps + .step-content,
.step-navigation {
    display: none !important;
}

li.step-item {
    font-size: 28px !important;
}

.step-item::before {
    height: 2px !important;
}

.b-steps
    .steps.is-small
    .step-items
    .step-item.is-primary.is-active
    .step-details
    .step-title {
    color: $grey-lighter !important;
    font-weight: bold !important;
}

.b-steps
    .steps.is-small
    .step-items
    .step-item.is-primary.is-previous
    .step-details
    .step-title {
    color: $grey-lighter !important;
}

.b-steps .steps.is-small .step-items .step-item .step-details .step-title {
    // font-family: AlkonFont !important;
    font-weight: normal !important;
    color: $grey-lighter !important;
    display: inline-block;
    margin-top: 10px;
    transition: 0.2s ease;
}

.b-steps .steps.is-small .step-items .step-item .step-marker {
    transition: 0.8s ease-out;
}

.b-steps .steps .step-items .step-item .step-marker {
    border-color: #f2f2f2 !important;
}

.b-steps .steps .step-items .step-item.is-active .step-marker {
    border-color: #4952ff !important;
}

.b-steps .steps .step-items .step-item.is-primary.is-active .step-marker {
    background-color: $primary !important;
    animation: blinking1 3s linear 0s infinite, blinking2 3s linear 0s infinite;
    height: 0.85rem !important;
    width: 0.85rem !important;
    margin-top: 0.4rem;
}

@keyframes blinking1 {
    0% {
        box-shadow: 0 0 5px 0px rgba(74, 98, 232, 0.15);
    }

    50% {
        box-shadow: 0 0 5px 8px rgba(74, 98, 232, 0.15);
    }

    100% {
        box-shadow: 0 0 5px 0px rgba(74, 98, 232, 0.15);
    }
}

@keyframes blinking2 {
    0% {
        box-shadow: 0 0 5px 8px rgba(97, 116, 235, 0.15);
    }

    50% {
        box-shadow: 0 0 5px 0px rgba(97, 116, 235, 0.15);
    }

    100% {
        box-shadow: 0 0 5px 8px rgba(97, 116, 235, 0.15);
    }
}

.b-checkbox.checkbox input[type="checkbox"] + .check {
    background: white !important;
    border: 2px solid #777 !important;
}

.b-checkbox.checkbox input[type="checkbox"]:checked + .check {
    background: #fff
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:black' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
        no-repeat center center !important;
}

.b-checkbox.checkbox input[type="checkbox"]:focus:checked + .check,
.b-checkbox.checkbox input[type="checkbox"]:focus + .check {
    box-shadow: none !important;
}

td.checkbox-cell {
    padding-top: 20px !important;
}

.user-shipment .table tr {
    transition: 0.4s ease-in;
}

.user-shipment .table tr.is-checked {
    background-color: #f7f8fa !important;
}

select {
    font-family: AlkonFont !important;
}

.pagination-link {
    border: none;
    background-color: #ebe9fb;
    color: $primary;
}

.pagination-previous,
.pagination-next {
    background-color: #d7d4f7;
}

.pagination-link.is-current,
.pagination-link.is-current {
    background-color: $primary !important;
    border-color: $primary !important;
}

.pagination-link {
    font-size: 12px !important;
}

.glide__track {
    margin-left: 15px !important;
    margin-right: 20px !important;
    width: calc(100% - 40px) !important;
}

.card-type .b-table .table th {
    background-color: #f1f3fa !important;
    border-color: #f1f3fa;
    color: #6c757d !important;
}

.b-table .table-wrapper.has-mobile-cards tr {
    display: table-row !important;
}

.card-type .table td {
    border-bottom: 1px solid #f1f3fa !important;
    padding-top: 15px;
    height: 50px;
    color: #6c757d;
}

.user-shipment .b-table .table {
    padding-left: 15px;
}

.cards .payment-tabs .b-tabs {
    max-width: 500px;
    display: inline-block;
}

//////////////////////

@media screen and (max-width: 400px) {
    .wpwl-brand.wpwl-brand-VISA.wpwl-brand-card {
        margin-top: 10px !important;
    }
}

.form2-units {
    width: 100%;
    margin-top: -2px;

    .select {
        width: 100%;

        select {
            background-color: transparent;
            border-color: transparent;
            text-align: center;

            &:hover,
            &:active,
            &:focus {
                border-color: transparent !important;
                box-shadow: none !important;
            }
        }
    }
}

select {
    &:hover,
    &:active,
    &:focus {
        border-color: #c2c2c2 !important;
        box-shadow: none !important;
    }
}

textarea {
    background: #f2f2f2 !important;
    border: none !important;

    &:hover,
    &:active,
    &:focus {
        border-color: #c2c2c2 !important;
        box-shadow: none !important;
    }
}

.modal-background {
    opacity: 0.8 !important;
}

.modal-close {
    background: $primary !important;
}

// .app-auth-page {
//     height: 1000px;
// }

.is-large.modal-close {
    display: none;
}

@media screen and (max-width: 1000px) {
    .b-table .table-wrapper.has-mobile-cards tr {
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
            0 0 0 1px rgba(10, 10, 10, 0.1) !important;
    }

    .b-table
        .table-wrapper.has-mobile-cards
        tr:not(.detail):not(.is-empty):not(.table-footer)
        td:before {
        content: attr(data-label) !important;
        font-weight: 600 !important;
        padding-right: 0.5em !important;
        text-align: left !important;
    }

    .b-table
        .table-wrapper.has-mobile-cards
        tr:not(.detail):not(.is-empty):not(.table-footer)
        td {
        display: flex !important;
        width: auto !important;
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;

        &.chevron-cell,
        &.checkbox-cell {
            display: none !important;
        }
    }

    .b-table .table-wrapper.has-mobile-cards thead {
        display: none !important;
    }
}

@media screen and (max-width: 900px) {
    .mobile-only-message {
        display: block;
    }

    .dropdown.is-mobile-modal > .dropdown-menu {
        z-index: 9999 !important;
    }
}

.navbar-burger {
    color: white !important;
    font-weight: bold !important;
    background-color: rgba(0, 0, 0, 0.15);
    width: 2.25rem !important;
    height: 2.25rem !important;
}

.navbar-dropdown {
    background-color: white !important;
    border-bottom-left-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
    -webkit-box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1) !important;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1) !important;
    display: none !important;
    font-size: 0.875rem !important;
    left: 0 !important;
    min-width: 100% !important;
    position: absolute !important;
    top: 100% !important;
    z-index: 20 !important;
}

.navbar-divider {
    display: block !important;
}

::placeholder {
    font-weight: 400;
    opacity: 0.8;
    /* Firefox */
}

:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-weight: 400;
    opacity: 0.8;
}

::-ms-input-placeholder {
    /* Microsoft Edge */
    font-weight: 400;
    opacity: 0.8;
}

.visaCheckbox[type="checkbox"]:focus {
    outline: 1px solid rgba(0, 0, 0, 0.2);
}

.visaCheckbox[type="checkbox"] {
    background-color: #ddd;
    border-radius: 2px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 17px;
    height: 17px;
    cursor: pointer;
    position: relative;
    top: 5px;
}

.visaCheckbox[type="checkbox"]:checked {
    background-color: #4952ff;
    background: #4952ff
        url("data:image/gif;base64,R0lGODlhCwAKAIABAP////3cnSH5BAEKAAEALAAAAAALAAoAAAIUjH+AC73WHIsw0UCjglraO20PNhYAOw==")
        3px 3px no-repeat;
    color: white;
}

.container {
    max-width: 100% !important;
    width: 87% !important;
    margin: auto;

    @media screen and (max-width: 1250px) {
        width: 95% !important;
    }

    @media screen and (max-width: 1100px) {
        width: 97% !important;
    }
    .input#map {
        width: 100% !important;
        border-bottom: 1px solid #ddd !important;
    }
}

.wpwl-form-card {
    min-height: 0px !important;
}
.wpwl-label-brand {
    display: none !important;
}
.wpwl-control-brand {
    display: none !important;
}
.wpwl-brand-card {
    display: block;
    visibility: visible;
    position: absolute;
    right: 200px;
    top: 40px;
    width: 65px;
    z-index: 10;
}
.wpwl-brand-MASTER {
    margin-top: -10;
    margin-right: -10;
}

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
